import http from '~/http/index';
import storeUtils from '~/utils/storeUtils';
import newhttp from '~/http/new';
import constant from '~/const';

export default ({
  state: {
    users: [],
    deletedUsers: [],
    filters: {},
    userTagListFilter: [],
    sort: {
      sort: null,
      sortDesc: true,
    },
    page: 1,
    pages: 0,
    pending: false,
    deletedUsersPage: 1,
    deletedUsersPages: 0,
    sortList: [
      { id: null, caption: 'Default' },
      { id: 'regDate', caption: 'Registration date' },
      { id: 'lastLoginDate', caption: 'Last activity date' },
      { id: 'verificationRequestDate', caption: 'Verification request date' },
    ],
    filterLists: {
      userStatusList: [
        { id: 0, caption: '0 – New' },
        { id: 1, caption: '1 – Confirmed' },
        { id: 2, caption: '2 – Verificated' },
      ],
      nfaServiceTypeList: [
        { id: 0, caption: 'Email' },
        { id: 1, caption: 'Telegram' },
        { id: 2, caption: 'Google' },
      ],
    },
    userTagsList: [],
  },

  getters: {
    setPending: (state) => (pending) => {
      state.pending = pending;
    },
    requestData(state, _getters, _rootState, rootGetters) {
      const {
        filters,
        userTagListFilter,
        sort,
        page,
      } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const filteredFilters = storeUtils.clearEmptyParams(filters);
      return {
        ...filteredFilters,
        ...sort,
        userTagList: userTagListFilter,
        offset: (page - 1) * itemsPerPage,
        limit: itemsPerPage,
        getTotal: true,
      };
    },

    appType() {
      return process.env.VUE_APP_EXCLUDE_FEATURE?.split(' ').includes('transactions-old');
    },

    getUserTagById: (state) => (id) => state.userTagsList.find((e) => e.id === id),

    getUserTagByTagName: (state) => (value) => state.userTagsList.find((e) => e.tagName === value),

    getUserTagsByIds: (__state, getters) => (data) => {
      if (!data) return [];

      return data
        .map((e) => getters.getUserTagById(e))
        .filter((e) => e);
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_SORT(state, data) { state.sort = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },
    SET_DELETED_USERS_PAGE(state, value) { state.deletedUsersPage = value; },
    SET_DELETED_USERS_PAGES(state, value) { state.deletedUsersPages = value; },

    SET_USERS(state, data) {
      state.users = data;
    },

    SET_DELETED_USERS(state, data) {
      state.deletedUsers = data;
    },

    EXTEND_USER(state, data) {
      const extendedData = state.users.map((e) => {
        if (e.id === data.id) {
          return {
            ...e,
            extendedUser: data,
          };
        }
        return e;
      });
      state.users = extendedData;
    },

    SET_USER_TAGS_LIST(state, data) {
      state.userTagsList = data;
    },

    SET_USER_TAG_LIST_FILTER(state, data) {
      state.userTagListFilter = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setSort({ commit }, data) { commit('SET_SORT', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },
    setDeletedUsersPage({ commit }, value) { commit('SET_DELETED_USERS_PAGE', value); },
    setDeletedUsersPages({ commit }, value) { commit('SET_DELETED_USERS_PAGES', value); },

    async getUsers({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.post('v2/User/GetUsers', {
        ...getters.requestData,
        ...data,
      });
      const { items, total } = response.data;
      commit('SET_USERS', items);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
      return items;
    },

    async getDeletedUsers(
      {
        getters, state, commit, rootGetters,
      },
      data,
    ) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const { deletedUsersPage } = state;
      const response = await http.post('v2/User/GetDeletedUsers', {
        ...getters.requestData,
        ...data,
        getTotal: true,
        offset: (deletedUsersPage - 1) * itemsPerPage,
        limit: itemsPerPage,
      });
      const { total } = response.data;
      commit('SET_DELETED_USERS', response.data);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_DELETED_USERS_PAGES', pages);
      }
    },

    async loadUser({ commit }, data) {
      const responses = await Promise.allSettled([
        http.post('v2/User/GetUser', data),
        http.get(`p2p/Admin/profile/${data.userId}/ban/info`),
      ]);
      if (responses[1]?.value?.data?.banUntil) {
        responses[0].value.data.userLockList = [
          ...responses[0].value.data.userLockList,
          {
            adminId: null,
            arbitratorId: null,
            comment: '',
            dateCreated: '',
            subType: null,
            type: constant.users.USER_LOCK_TYPE.P2P_IGNORE_CONFIRMATIONS_BAN,
            until: responses[1].value.data.banUntil,
          },
        ];
      }
      commit('EXTEND_USER', responses[0].value.data);
      return responses[0].value.data;
    },

    async getUser(__store, userId) {
      const responses = await Promise.allSettled([
        http.post('v2/User/GetUser', { userId }),
        http.get(`p2p/Admin/profile/${userId}/ban/info`),
      ]);
      if (responses[1]?.value?.data?.banUntil) {
        responses[0].value.data.userLockList = [
          ...responses[0].value.data.userLockList,
          {
            adminId: null,
            arbitratorId: null,
            comment: '',
            dateCreated: '',
            subType: null,
            type: constant.users.USER_LOCK_TYPE.P2P_IGNORE_CONFIRMATIONS_BAN,
            until: responses[1].value.data.banUntil,
          },
        ];
      }
      return responses[0].value.data;
    },

    async getUsersByParams(__store, data) {
      const response = await http.post('v2/User/GetUsers', data);
      return response.data;
    },

    async changeIdentificator(__store, data) {
      await newhttp.put(`v1/user/${data.id}/identificator`, { identificator: data.newIdentificator });
    },

    async getUsersByExactParams(__store, data) {
      try {
        const response = await http.post('v2/User/GetUsers', data);
        return response.data;
      } catch (error) {
        return [];
      }
    },

    async getUserIdByUserName(__store, userName) {
      try {
        const response = await http.post('v2/User/GetUsers', {
          userName,
          limit: 1,
          offset: 0,
        });
        const user = response.data.items[0];
        if (user && user.userName === userName) {
          return user.id;
        }
        return false;
      } catch (__error) {
        return false;
      }
    },

    setUserTagListFilter({ commit }, data) {
      commit('SET_USER_TAG_LIST_FILTER', data);
    },

    async getUserTagsList({ commit }, data = { searchString: '' }) {
      const response = await http.post('v2/User/GetUserTags', data);
      const { items } = response.data;
      commit('SET_USER_TAGS_LIST', items);
    },

    async removeTagsFromUser(__state, data) {
      await http.put('v2/User/RemoveTagsFromUser', data);
    },

    async addUserTag(__state, data) {
      await http.post('v2/User/AddUserTag', data);
    },

    async editUserTag(__state, data) {
      await http.put('v2/User/EditUserTag', data);
    },

    async deleteUserTag(__state, tagId) {
      await http.put('v2/User/DeleteUserTag', { tagId });
    },

    async addTagsToUser(__state, data) {
      await http.put('v2/User/AddTagsToUser', data);
    },

    async usersLock(__store, data) {
      await http.put('v2/User/UsersLock', data);
    },

    async usersUnlock(__store, data) {
      if (data.type === constant.users.USER_LOCK_TYPE.P2P_IGNORE_CONFIRMATIONS_BAN) {
        await http.post(`p2p/Admin/profile/${data.userIds[0]}/unblock`);
      } else {
        await http.put('v2/User/UsersUnlock', data);
      }
    },

    async usersBlock(__store, data) {
      await http.put('v2/User/UsersBlock', data);
    },

    async usersUnblock(__store, data) {
      await http.put('v2/User/UsersUnblock', data);
    },

    async expandUserData({ dispatch }, {
      data = [],
      getId = (e) => e.userId,
      key = 'user',
    }) {
      const userIdList = data.map((e) => getId(e));
      const requestParams = {
        userIdList,
        limit: data.length,
        getTotal: false,
      };
      const { items } = await dispatch('getUsersByParams', requestParams);
      return data.map((dataItem) => {
        if (Object.prototype.hasOwnProperty.call(dataItem, key)) {
          throw new Error(`Property "${key}" already exist in data item`);
        }
        const user = items.find((userItem) => userItem.id === getId(dataItem));
        return {
          ...dataItem,
          [key]: user,
        };
      });
    },

    async updateUserTransactionLimit(__store, data) {
      const response = await http.put('v2/Transaction/UpdateUserTransactionLimit', data);
      return response.data;
    },

    async deleteUserTransactionLimit(__store, data) {
      const response = await http.put('v2/Transaction/DeleteUserTransactionLimit', data);
      return response.data;
    },

    async createUser({ getters }, data) {
      const url = getters.appType ? 'v1/user' : 'v2/User/CreateUser';
      const protocol = getters.appType ? newhttp : http;
      const method = 'post';

      const requestData = { ...data };
      const response = await protocol[method](url, requestData);

      return response.data;
    },

    async addUserRole({ getters }, data) {
      const url = getters.appType ? `v1/user/${data.id}/role/${data.role}` : 'v2/User/AddUserRole';
      const protocol = getters.appType ? newhttp : http;
      const method = 'put';

      const requestData = getters.appType
        ? { comment: data.comment }
        : { ...data };

      await protocol[method](url, requestData);
    },

    async removeUserRole({ getters }, data) {
      const url = getters.appType ? `v1/user/${data.id}/role/${data.role}` : 'v2/User/RemoveUserRole';
      const protocol = getters.appType ? newhttp : http;
      const method = getters.appType ? 'delete' : 'put';

      const requestData = method === 'delete'
        ? { data: { comment: data.comment } }
        : { ...data };

      await protocol[method](url, requestData);
    },
  },

  namespaced: true,
});
